<template>
<div class="Main">
  <template>
    <Slide>
      <router-link to="/dashboard">Homepage</router-link>
      <router-link to="/main">Main Menu</router-link>
      <a class="cpointer" @click="$router.go(-1)">Back</a>
    </Slide>
</template>
  <div class="container">
    <div class="row">
      <div class="col s12 m12 logo-box">
        <h1 class="titleh1">ARCH STAFF INFORMATION CHANNEL</h1>
      </div>
      <div class="clearfix"></div>
      <div class="col s12">
        <div class="row">
          <div v-for="category in PageData" class="col s12 m4">
            <div class="img_box_home">
              <router-link :to="'directory/' + category.slug" :title="category.name">
              <v-lazy-image class="img-responsive" :src="category.cover" :alt="category.name" />
                </router-link> <br />
              <p>
                <router-link :to="'directory/' + category.slug">{{category.name}}</router-link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
  <FooterText />
</div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import {
  Slide
} from 'vue-burger-menu'
import VLazyImagePlugin from 'v-lazy-image'
import FooterText from './Footertext'
export default {
  name: 'Main',
  data() {
    return {
      usercookie: $cookies.get('arch-asic'),
      PageData: []
    }
  },
  components: {
    Slide,
    FooterText
  },
  methods: {
    fetchDataMain: function() {
      axios({
        method: 'post',
        url: 'https://www.archipelagointernational.com/api/asic/query',
        data: {
          query: `
          query {
            maincategory {
                name,
                slug,
                cover
            }
          }
          `
        },
        headers: {
          'Authorization': 'Bearer ' + this.usercookie,
          'Content-Type': 'application/json'
        }
      }).then(response => (this.PageData = response.data.data.maincategory));
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    loginstatus: function(e) {
      if (e != 'Success') {
        //console.log(e);
        router.push({
          name: 'Login'
        })
      } else {
        //this.isLogin = true
        //console.log(e);
      }
    }
  },
  created() {
    this.fetchDataMain();
  },
  mounted() {
    this.toggleBodyClass('addClass', 'back-directory');
  },
  destroyed() {
    this.toggleBodyClass('removeClass', 'back-directory');
  }
}
</script>

<style>
.back-directory {
  background: url(https://cdn0.archipelagointernational.com/StaffCentre/assets/images/background-v4.jpg) center center no-repeat fixed #00215B;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue